const checkConnectionStatus = async (): Promise<boolean> => {
  if (navigator.onLine) {
    return Promise.resolve(true);
  } else {
    return Promise.resolve(false);
  }
};

export default checkConnectionStatus;
